import React, { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import {
	Switch,
	Input,
	Modal,
	Alert,
	Spin,
	Select,
	Popover,
	message,
	DatePicker,
	Checkbox,
} from 'antd';
import { connect } from 'react-redux';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import {
	getObjectValues,
	nullSafeGet,
	nullSafeGetOrElse,
	getCurrency,
	mergeTypeFields,
	mergeTypeFieldsInit,
	isSupplierPayingCustomerAndAdmin,
	getCustomFieldsForAPI,
} from '../../utils/DataAccessUtils';
import BackButton from '../back_button/BackButton';
import {
	locationTypesRestCrudThunksForBuyer,
	locationTypesRestCrudThunksForSupplier,
} from '../../thunks/location_types_thunks';
import { debounce } from '../../utils/PerformanceUtils';
import { getRecordsForTargetCollection } from '../../reducers/standard_reducer_utils';
import { imageUploadValidation, normFile } from '../../utils/ImageUtils';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import { LocationAutocomplete } from '../location_autocomplete/LocationAutocomplete';
import { getProtectedImageUriForBuyer } from '../../utils/FileAccessUtils';
import {
	buyerFacilitiesRestCrudThunksForBuyer,
	buyerFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/buyer_facilities_thunks';
import {
	buyerContactsRestCrudThunksForBuyer,
	buyerContactsRestCrudThunksForSupplier,
} from '../../thunks/buyer_contacts_thunks';
import { DAYS_OF_THE_WEEK } from '../../constants/times';
import { capitalize } from '../../utils/DataFormatterUtils';
import moment from 'moment';
import {
	fetchRegionsWithChildrenForBuyer,
	fetchRegionsWithChildrenForSupplier,
	regionsRestCrudThunksForBuyer,
	regionsRestCrudThunksForSupplier,
} from '../../thunks/regions_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { BUYER_SUPPLIER_ADMIN_ROLES, hasRequiredRole } from '../roles/roles';
import MultiEmailComponentAntdV3 from '../MultiEmailComponent/MultiEmailComponentAntdV3';
import { CURRENCIES, filterCurrencyOption, ROLE_TYPES } from '../../utils/DataConstants';
import PhoneNumberComponent from '../PhoneNumberComponent/PhoneNumberComponentAntdV3';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import OWButton from '../ow_button/OWButton';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import {
	brandAssetGroupsRestCrudThunksForBuyer,
	brandAssetGroupsRestCrudThunksForSupplier,
} from '../../thunks/brand_asset_groups_thunks';
import {
	assetsRestCrudThunksForBuyer,
	assetsRestCrudThunksForSupplier,
} from '../../thunks/assets_thunks';
import OWDateRangePicker from '../ow_date_range_picker/OWDateRangePicker';
import OWUpload from '../OWUpload';
import { customersRestCrudThunksForSupplier } from '../../thunks/customers_thunks';
import ClearErrors from '../clear_errors/ClearErrors';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';
import {
	getCustomFieldsForBuyer,
	getCustomFieldsForSupplier,
} from '../../thunks/custom_fields_thunks';
import CustomFieldItems from '../custom_fields_items/CustomFieldItems';
import {
	addressValidatorFormv3,
	setAddressFormFields,
	getAddressFromFormFields,
	BRAND_ASSET_GROUP_FEATURE_FLAG,
} from '../../utils/LocationUtils';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import {
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';
import LocationFormHoursComponent from '../location_form_hours_component/LocationFormHoursComponent';
import posthog from 'posthog-js';

const LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE = 'LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE';
const LOCATION_FORM_REGIONS_AUTOCOMPLETE = 'LOCATION_FORM_REGIONS_AUTOCOMPLETE';
const LOCATION_FORM_BUYER_CONTACTS_AUTOCOMPLETE = 'LOCATION_FORM_BUYER_CONTACTS_AUTOCOMPLETE';
const REGIONS_WITH_CHILDREN = 'regionsWithChildrenDropdown';
const LOCATION_FORM_AUTOCOMPLETE = 'locationFormIndex';

const dateFormat = 'MMMM DD, YYYY';

interface LocationFormProps extends FormComponentProps {
	creating: boolean;
	updating: boolean;
	formData: any;
	history: any;
	locationTypesFetching: any;
	locationTypes: any;
	regionsFetching: any;
	regions: any;
	fetchRegion: any;
	fetchRegions: any;
	createRegion: any;
	buyerContactsFetching: any;
	buyerContacts: any;
	fetchLocationType: any;
	fetchLocationTypes: any;
	fetchBuyerContacts: any;
	redirectForwardUrl?: string;
	onSuccess?: any;
	createErrors: any[];
	updateErrors: any[];
	currentUser: any;
	create: any;
	createBuyerFacility: any;
	updateBuyerFacility: any;
	fetchRegionsWithChildren: any;
	update: any;
	userType: any;
	brands: any;
	customers: any;
	fetchBrands: any;
	fetchCustomers: any;
	getCustomFields: any;
	fetchProblemTypes: any;
	problemTypes: any;
	supplierFacilities: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	companyConfig: any;
	fetchBrandAssetGroups: (brandId: number) => Promise<any[]>;
	countAssets: (params: any) => Promise<any>;
}

class LocationForm extends React.Component<LocationFormProps, any> {
	state = {
		region: {},
		regionName: null,
		locationType: {
			optionalFields: [],
			requiredFields: [],
		},
		previewVisible: false,
		previewImage: null,
		uploadLoading: false,
		allPhotos: [],
		isLoading: false,
		customFields: [],
		openKeys: [],
		assetGroupOptions: [] as { label: string; value: number }[],
		assetGroupsFetching: false,
		assetGroupFieldDisabled: true,
	};

	componentDidMount() {
		const {
			getCustomFields,
			formData,
			fetchLocationType,
			fetchLocationTypes,
			fetchRegions,
			fetchBuyerContacts,
		} = this.props;
		const locationTypeId = formData.locationTypeId;

		fetchBuyerContacts();
		fetchLocationTypes({ limit: 50, offset: 0 });
		fetchRegions({ limit: 50, offset: 0 });
		getCustomFields({ onEntity: 'location' }).then((data) => {
			this.setState({ customFields: data });
		});
		// TODO: HYDRATE THESE IN THE ROUTE AND REMOVE
		if (locationTypeId) {
			fetchLocationType(locationTypeId).then((lt) => {
				const currentLocationTypeDetails = formData.locationTypeDetails || [];
				const mergedLocationType = mergeTypeFieldsInit(currentLocationTypeDetails, lt);

				this.setState({
					locationType: mergedLocationType,
				});
			});
		}

		let photosInfo;
		if (formData.images) {
			photosInfo = formData.images.map((p, idx) => {
				const [imgFileId, imgFileName] = p.split('/');
				const thumbUri = getProtectedImageUriForBuyer(imgFileId, imgFileName, 100, 100);
				const fullUri = getProtectedImageUriForBuyer(imgFileId, imgFileName, 400, 400);
				return {
					uid: idx,
					size: 1,
					name: imgFileName,
					filename: imgFileName,
					url: fullUri,
					status: 'done',
					thumbUrl: thumbUri,
					response: { data: { fileName: imgFileName, fileId: imgFileId } },
					type: 'image/jpeg',
				};
			});
		} else {
			photosInfo = [];
		}
		this.setState({ allPhotos: photosInfo });

		if (formData.id) {
			this.props
				.countAssets({ locationId: formData.id })
				.then((count) => this.setState({ assetGroupFieldDisabled: count > 0 }))
				.catch(() => this.setState({ assetGroupFieldDisabled: true }));
		} else {
			this.setState({ assetGroupFieldDisabled: false });
		}
		if (formData.brandId) {
			this.loadAssetGroups(formData.brandId);
		}
	}

	loadAssetGroups = (brandId) => {
		this.setState({ assetGroupsFetching: true, assetGroupOptions: [] });
		this.props
			.fetchBrandAssetGroups(brandId)
			.then((groups) =>
				this.setState({
					assetGroupOptions: (groups || []).map((g) => ({ label: g.name, value: g.id })),
				})
			)
			.catch(() => this.setState({ assetGroupOptions: [] }))
			.finally(() => this.setState({ assetGroupsFetching: false }));
	};

	saveLocation = (values, submitAction) => {
		const {
			history,
			redirectForwardUrl,
			currentUser,
			onSuccess,
			updateBuyerFacility,
			createBuyerFacility,
			form,
			formData,
			companyConfig,
			userType,
		} = this.props;

		const { locationType } = this.state;
		const enableBillTo = getBuyerCompanySettingValue(userType)(
			'locationConfig.enableBillToAddressesForLocation',
			companyConfig,
			currentUser
		);
		this.setState({ isLoading: true });

		// put image data into proper format to persist
		const picturesInfo = values.images.map((p) => {
			const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
			const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
			return `${fileId}/${fileName}`;
		});
		const openKeys = values.openKeys || [];

		const operatingHours = DAYS_OF_THE_WEEK.filter((day) => openKeys.includes(day)).reduce(
			(acc, day) => {
				const from = nullSafeGet(`${day}.from`, values);
				const to = nullSafeGet(`${day}.to`, values);

				if (from && to && moment.isMoment(from) && moment.isMoment(to)) {
					acc[day] = {
						from: from.format('h:mm a'),
						to: to.format('h:mm a'),
					};
				}
				return acc;
			},
			{}
		);

		// construct address json from flattened fields
		const primaryAddress = Object.keys(values)
			.filter((k) => k.indexOf('primaryAddress') > -1)
			.reduce((acc, k) => {
				const [_, x] = k.split('-');
				acc[x] = values[k];
				return acc;
			}, {});

		// Combine required and optional fields into one array
		const locationTypeDetails = (locationType.requiredFields || [])
			.concat(locationType.optionalFields || [])
			.filter((field) => !field.remove)
			.map((field) => ({
				key: form.getFieldValue(`${field.key}-key`),
				valueType: form.getFieldValue(`${field.key}-valueType`),
				valueAsString: form.getFieldValue(`${field.key}-valueAsString`),
			}));

		const customFieldDetails = getCustomFieldsForAPI(values, this.state.customFields);

		const buyerFacility = {
			...nullSafeGetOrElse('buyerFacility', formData, {}),
			id: values.buyerFacilityId,
			name: values.name,
			displayName: values.name,
			primaryContactEmail: currentUser.email,
			primaryAddress,
			latitude: values.latitude,
			longitude: values.longitude,
			status: 'active',
			buyerCompanyId: isSupplierPayingCustomerAndAdmin(currentUser)
				? values.buyerCompanyId
				: nullSafeGet('facility.buyerCompanyId', currentUser),
			currencyId: values.currencyId || 'USD',
		};

		const [buildingWarrantyStartDate, buildingWarrantyExpirationDate] =
			values.buildingWarrantyPeriod || [];

		const location = {
			...formData,
			id: values.id,
			name: values.name,
			description: values.description,
			isActive: values.isActive,
			buyerFacilityId: values.buyerFacilityId,
			images: picturesInfo,
			operatingHours,
			phoneNumber: values.phoneNumber,
			currencyId: values.currencyId || 'USD',
			storeId: values.storeId,
			brandId: values.brandId ? parseInt(values.brandId, 10) : undefined,
			brandAssetGroupId: values.brandAssetGroupId
				? parseInt(values.brandAssetGroupId, 10)
				: undefined,
			regionId: values.regionId,
			facilityInChargeEmail: values.facilityInChargeEmail,
			facilityInChargeEmails: isSupplierPayingCustomerAndAdmin(currentUser)
				? values.primaryContactsEmails
				: values.facilityInChargeEmails,
			sendApprovedInvoicesToEmails: values.sendApprovedInvoicesToEmails,
			sendApprovedQuotesToEmails: values.sendApprovedQuotesToEmails,
			primaryContactsEmails: values.primaryContactsEmails,
			locationTypeId: isSupplierPayingCustomerAndAdmin(currentUser)
				? 1
				: parseInt(values.locationTypeId, 10),

			locationTypeDetails: locationTypeDetails.filter(
				(field) => field.valueAsString !== undefined && field.valueAsString !== ''
			),
			customFieldDetails: customFieldDetails.filter(
				(field) => field.valueAsString !== undefined && field.valueAsString !== ''
			),
			notes: formData.notes,
			internalNotes: formData.internalNotes,
			internalAttachments: values.internalAttachments,
			isLeased: values.isLeased,
			leaseStartDate: values.leaseStartDate,
			leaseEndDate: values.leaseEndDate,
			buildingWarrantyStartDate: buildingWarrantyStartDate,
			buildingWarrantyExpirationDate: buildingWarrantyExpirationDate,
			buildingWarrantyProblemTypeIds: values.allProblemTypes
				? undefined
				: nullSafeGet('buildingWarrantyProblemTypeIds.0', values)
				? values.buildingWarrantyProblemTypeIds
				: undefined,
			buildingWarrantyServiceProviderId: values.buildingWarrantyServiceProviderId,
			openDate: values.openDate,
			closeDate: values.closeDate,
			buyerCompanyId: isSupplierPayingCustomerAndAdmin(currentUser)
				? values.buyerCompanyId
				: undefined,
			invoicesBillTo:
				enableBillTo && values.invoiceBillTo
					? {
							billTo: values.invoiceBillTo,
							serviceAddress: values.invoiceServiceAddressSameAsLocation
								? { sameAsLocation: true }
								: getAddressFromFormFields(values, 'invoiceServiceAddress'),
					  }
					: undefined,
		};

		const handleSubmitSuccess = (newBuyerFacility) => {
			location.buyerFacilityId = newBuyerFacility.id;
			submitAction(location)
				.then((record) => {
					if (redirectForwardUrl) {
						history.push(redirectForwardUrl);
					}
					if (onSuccess) {
						onSuccess(record);
					}
				})
				.catch((err) => message.error(err))
				.finally(() => this.setState({ isLoading: false }));
		};

		if (!values.buyerFacilityId) {
			createBuyerFacility(buyerFacility)
				.then(handleSubmitSuccess)
				.catch((err) => {
					message.error(err);
					this.setState({ isLoading: false });
				});
		} else {
			updateBuyerFacility(buyerFacility)
				.then(handleSubmitSuccess)
				.catch((err) => {
					message.error(err);
					this.setState({ isLoading: false });
				});
		}
	};

	handleSubmit = (e, submitAction) => {
		e.preventDefault();
		Promise.resolve().then(() => {
			this.props.form.validateFields((err, values) => {
				if (!err) {
					this.saveLocation(values, submitAction);
				} else {
					this.props.form.validateFields((err, values) => {
						/*
						Doing a second time validation on error, because antd form throws an error for email fields on first time validation
						Fix proposed is to use the Form.useForm which we already use in other place.
						That needs to be worked on immediately after. This is only a temporary solution
						*/
						if (!err) this.saveLocation(values, submitAction);
					});
				}
			});
		});
	};

	handlePreview = (file) => {
		this.setState({
			previewImage: file.url || file.thumbUrl,
			previewVisible: true,
		});
	};

	handleImageUpdate = (info) => {
		if (info.file.status === 'done') {
			this.setState({ allPhotos: info.fileList });
		} else if (info.file.status === undefined) {
			info.fileList = this.state.allPhotos;
		}
	};

	debouncedSearchLocationTypes = debounce(
		(searchText) => {
			const { fetchLocationTypes } = this.props;
			fetchLocationTypes({ name: searchText && searchText.trim() });
		},
		500,
		false
	);

	handleLocationTypeChange = (locationTypeId) => {
		const { fetchLocationType } = this.props;
		const { locationType } = this.state;
		if (locationTypeId) {
			fetchLocationType(locationTypeId).then((newLocationType) => {
				const updatedLocationType = mergeTypeFields(locationType, newLocationType);
				this.setState({ locationType: updatedLocationType });
			});
		}
	};

	regionNameChange = (text) => {
		this.setState({
			regionName: text,
		});
	};

	debouncedSearchRegions = debounce(
		(searchText) => {
			const { fetchRegions } = this.props;
			this.regionNameChange(searchText && searchText.trim());
			fetchRegions({ name: searchText && searchText.trim() });
		},
		500,
		false
	);

	addRegion = () => {
		const { regionName } = this.state;
		const { createRegion, currentUser, fetchRegions } = this.props;
		const buyerCompanyId = nullSafeGet('facility.buyerCompanyId', currentUser);
		if (regionName && buyerCompanyId) {
			createRegion({ name: regionName, buyerCompanyId }).then(() => {
				fetchRegions({ limit: 50, offset: 0 });
			});
		}
	};

	handleRegionChange = (regionId) => {
		const { fetchRegion } = this.props;
		if (regionId) {
			fetchRegion(regionId).then((r) => this.setState({ region: r }));
		}
	};

	debouncedSearchBuyerContacts = debounce(
		(searchText) => {
			const { fetchBuyerContacts } = this.props;
			fetchBuyerContacts({ email: searchText && searchText.trim() });
		},
		500,
		false
	);

	searchBuyerContacts = (searchText) => {
		this.debouncedSearchBuyerContacts(searchText);
	};

	searchLocationTypes = (searchText) => {
		this.debouncedSearchLocationTypes(searchText);
	};

	searchRegions = (searchText) => {
		this.debouncedSearchRegions(searchText);
	};

	handleCancel = () => this.setState({ previewVisible: false });

	handleLocationAutocompleteSelect = (addr, lonLat, parsedAddress) => {
		const { form } = this.props;

		setAddressFormFields(form, 'primaryAddress', 'addressInput', parsedAddress);
		form.setFieldsValue({
			longitude: lonLat.lng,
			latitude: lonLat.lat,
		});
		form.validateFields(['addressInput']);
	};

	handleInvoiceServiceAddressSameAsLocationChange = (e) => {
		const { form } = this.props;
		const checked = e.target.checked;
		form.setFieldsValue({ invoiceServiceAddressSameAsLocation: checked });
		if (checked) {
			setAddressFormFields(form, 'invoiceServiceAddress', null, {});
		}
	};

	handleUploadChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ uploadLoading: true });
			return;
		}
		if (info.file.status === 'done') {
			this.setState({
				uploadLoading: false,
			});
			return;
		}
		if (info.file.status === 'error') {
			this.setState({ uploadLoading: false });
		}
	};

	handleLeaseDateChange = (values) => {
		const { form } = this.props;
		if (values) {
			const [leaseStartDate, leaseEndDate] = values;
			form.setFieldsValue({ leaseStartDate, leaseEndDate });
		} else {
			form.setFieldsValue({
				leaseStartDate: undefined,
				leaseEndDate: undefined,
			});
		}
	};

	render() {
		const {
			form,
			update,
			create,
			createErrors,
			formData,
			locationTypes,
			locationTypesFetching,
			updateErrors,
			currentUser,
			regions,
			fetchRegionsWithChildren,
			userType,
			brands,
			customers,
			fetchBrands,
			fetchCustomers,
			history,
			fetchProblemTypes,
			problemTypes,
			supplierFacilities,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchMultipleSupplierFacilitiesInPrivateNetwork,
			companyConfig,
		} = this.props;
		const { locationType, previewImage, previewVisible } = this.state;
		const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
		const userRoles = nullSafeGetOrElse('roles', currentUser, []);
		const isAdmin = hasRequiredRole(userRoles, BUYER_SUPPLIER_ADMIN_ROLES);
		const isUpdate = formData && formData.id !== undefined;
		const submitAction = isUpdate ? update : create;
		const submitText = isUpdate ? 'Update location' : 'Create location';
		const locationTypesDropdownRecords = getRecordsForTargetCollection(
			locationTypes,
			LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE
		);
		const currencyRecordsList = getObjectValues(CURRENCIES);
		const createRawAddress = (addr) => {
			if (!addr || addr === undefined) {
				return '';
			}
			return `${addr.streetAddress1}  ${addr.city}, ${addr.region}, ${addr.postcode}, ${addr.country}`;
		};
		const rawAddress = createRawAddress(nullSafeGet('buyerFacility.primaryAddress', formData));

		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };

		let initialLocationDetailsMap = {};
		if (formData.locationTypeDetails) {
			formData.locationTypeDetails.forEach((ltd) => {
				initialLocationDetailsMap[`${ltd.key}-key`] = ltd.key;
				initialLocationDetailsMap[`${ltd.key}-valueType`] = ltd.valueType;
				initialLocationDetailsMap[`${ltd.key}-valueAsString`] = ltd.valueAsString;
			});
		}
		const getFieldItems = (lt) => {
			if (!lt || !lt.id) {
				return null;
			}

			return [...(lt.requiredFields || []), ...(lt.optionalFields || [])].map((field) => {
				getFieldDecorator(`${field.key}-key`, { initialValue: field.key });
				getFieldDecorator(`${field.key}-valueType`, {
					initialValue: field.type || field.valueType,
				});

				return (
					<Form.Item label={field.key} key={field.key} hidden={field.remove}>
						{form.getFieldDecorator(`${field.key}-valueAsString`, {
							validateTrigger: ['onChange', 'onBlur'],
							initialValue: initialLocationDetailsMap[`${field.key}-valueAsString`],
							rules: lt.requiredFields.some((reqField) => reqField.key === field.key)
								? [{ required: true, message: 'This field is required.' }]
								: [],
						})(<Input />)}
					</Form.Item>
				);
			});
		};

		getFieldDecorator(`id`, { initialValue: formData.id });
		getFieldDecorator(`buyerFacilityId`, { initialValue: formData.buyerFacilityId });
		getFieldDecorator(`longitude`, {
			initialValue: nullSafeGet('buyerFacility.longitude', formData),
		});
		getFieldDecorator(`latitude`, {
			initialValue: nullSafeGet('buyerFacility.latitude', formData),
		});
		getFieldDecorator(`primaryAddress-streetAddress1`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.streetAddress1', formData),
		});
		getFieldDecorator(`primaryAddress-city`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.city', formData),
		});
		getFieldDecorator(`primaryAddress-region`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.region', formData),
		});
		getFieldDecorator(`primaryAddress-streetAddress2Opt`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.streetAddress2Opt', formData),
		});
		getFieldDecorator(`primaryAddress-postcode`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.postcode', formData),
		});
		getFieldDecorator(`primaryAddress-country`, {
			initialValue: nullSafeGet('buyerFacility.primaryAddress.country', formData),
		});
		getFieldDecorator('status', { initialValue: 'active' });
		const serviceAddress = nullSafeGet('invoicesBillTo.serviceAddress', formData) || {};
		const hasServiceAddressFields =
			nullSafeGet('streetAddress1', serviceAddress) ||
			nullSafeGet('city', serviceAddress) ||
			nullSafeGet('region', serviceAddress) ||
			nullSafeGet('postcode', serviceAddress) ||
			nullSafeGet('country', serviceAddress);
		const isSameAsLocation = !hasServiceAddressFields;
		const isNewLocation = !nullSafeGet('id', formData);
		getFieldDecorator('invoiceBillTo', {
			initialValue:
				nullSafeGet('invoicesBillTo.billTo', formData) ||
				(isNewLocation ? nullSafeGet('facility.buyerCompany.name', currentUser) : undefined),
		});
		getFieldDecorator('invoiceServiceAddressSameAsLocation', {
			initialValue: isSameAsLocation,
			valuePropName: 'checked',
		});
		getFieldDecorator('invoiceServiceAddress-streetAddress1', {
			initialValue: isSameAsLocation
				? undefined
				: nullSafeGet('invoicesBillTo.serviceAddress.streetAddress1', formData),
		});
		getFieldDecorator('invoiceServiceAddress-streetAddress2Opt', {
			initialValue: isSameAsLocation
				? undefined
				: nullSafeGet('invoicesBillTo.serviceAddress.streetAddress2Opt', formData),
		});
		getFieldDecorator('invoiceServiceAddress-city', {
			initialValue: isSameAsLocation
				? undefined
				: nullSafeGet('invoicesBillTo.serviceAddress.city', formData),
		});
		getFieldDecorator('internalAttachments', { initialValue: formData.internalAttachments || [] });
		const sendApprovedInvoicesToEmailsInitialValue =
			formData.sendApprovedInvoicesToEmails && formData.sendApprovedInvoicesToEmails.length > 0
				? formData.sendApprovedInvoicesToEmails
				: [];
		getFieldDecorator('sendApprovedInvoicesToEmails', {
			initialValue: sendApprovedInvoicesToEmailsInitialValue,
		});
		const facilityInChargeEmailsInitialValue =
			formData.facilityInChargeEmails && formData.facilityInChargeEmails.length > 0
				? formData.facilityInChargeEmails
				: [formData.facilityInChargeEmail || currentUser.email];
		getFieldDecorator('facilityInChargeEmails', {
			initialValue: facilityInChargeEmailsInitialValue,
		});
		const primaryContactsEmailsInitialValue =
			formData.primaryContactsEmails && formData.primaryContactsEmails.length > 0
				? formData.primaryContactsEmails
				: [currentUser.email];
		getFieldDecorator('primaryContactsEmails', {
			initialValue: primaryContactsEmailsInitialValue,
		});

		getFieldDecorator('leaseStartDate', {
			initialValue: formData.leaseStartDate,
		});
		getFieldDecorator('leaseEndDate', {
			initialValue: formData.leaseEndDate,
		});

		const buildingWarrantyEnabled = getBuyerCompanySettingValue(userType)(
			'locationConfig.buildingWarrantyEnabled',
			companyConfig,
			currentUser
		);

		const enableBillTo = getBuyerCompanySettingValue(userType)(
			'locationConfig.enableBillToAddressesForLocation',
			companyConfig,
			currentUser
		);

		const sameAsLocationChecked = getFieldValue('invoiceServiceAddressSameAsLocation');

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');
		//TODO: UPGRADE FORM

		const buildingWarrnatyPeriodSelected = (getFieldValue('buildingWarrantyPeriod') || []).some(
			(_) => !!_
		);
		const allProblemTypesSelected = getFieldValue('allProblemTypes');

		return (
			<Form
				layout="vertical"
				onSubmit={(e) => this.handleSubmit(e, submitAction)}
				className="supplierForm"
				style={{ maxWidth: 600 }}
			>
				<ClearErrors actionCreators={LOCATIONS_CRUD_ACTION_CREATORS} />
				{createErrors.length > 0 ? (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{updateErrors.length > 0 ? (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				) : null}
				{isSupplierPayingCustomerAndAdmin(currentUser) ? (
					<Form.Item label="Customer">
						{getFieldDecorator('buyerCompanyId', {
							initialValue: formData.buyerCompanyId,
							rules: [{ required: true, message: 'Please select a customer' }],
						})(
							<OWAsyncSelect
								stateSlice={customers}
								targetCollectionName={'customersIndex'}
								fetchMultiple={(ids, targetCollectionName) => {}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchCustomers(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								createNewEntity={(name) => {
									return new Promise((resolve) => {
										history.push('/supplier/locations/overview/customers/overview');
										resolve();
									});
								}}
								renderRecord={(customer) => (
									<Select.Option key={customer.id} value={customer.id}>
										{customer.displayName || customer.name}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
							/>
						)}
					</Form.Item>
				) : null}
				<Form.Item label="Name">
					{getFieldDecorator('name', {
						initialValue: formData.name,
						rules: [{ required: true, message: 'Please give the location a name.' }],
					})(<Input />)}
				</Form.Item>
				<Form.Item required={true} label="Address">
					<div>
						{getFieldDecorator('addressInput', {
							initialValue: nullSafeGet('buyerFacility.primaryAddress', formData),
							rules: [
								{
									required: true,
									message: 'Please search for and select a valid address',
									validator: addressValidatorFormv3(form),
								},
							],
						})(
							<LocationAutocomplete
								initialValue={rawAddress}
								placeholder="Search for and select an address"
								lat={getFieldValue('latitude')}
								lon={getFieldValue('longitude')}
								showCoordinateEditor={true}
								onSelect={this.handleLocationAutocompleteSelect}
							/>
						)}
					</div>
				</Form.Item>
				<Form.Item label="Store ID">
					{getFieldDecorator('storeId', {
						initialValue: formData.storeId,
						rules: [{ required: true, message: 'Please specify location id.' }],
					})(<Input />)}
				</Form.Item>
				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<Form.Item label="Brand">
						{getFieldDecorator('brandId', {
							initialValue: formData.brandId,
						})(
							<OWAsyncSelect
								stateSlice={brands}
								targetCollectionName={'brandsIndex'}
								fetchMultiple={(ids, targetCollectionName) => {}}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchBrands(
										{ brandName: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(brand) => (
									<Select.Option key={brand.id} value={brand.id}>
										{brand.brandName}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'title', order: 'ascend' }}
								onChange={(brandId) => {
									form.setFieldsValue({ brandAssetGroupId: undefined });
									if (brandId) {
										this.loadAssetGroups(brandId);
									} else {
										this.setState({ assetGroupOptions: [] });
									}
								}}
							/>
						)}
					</Form.Item>
				)}

				{posthog.isFeatureEnabled(BRAND_ASSET_GROUP_FEATURE_FLAG) &&
				!isSupplierPayingCustomerAndAdmin(currentUser) &&
				form.getFieldValue('brandId') ? (
					<Form.Item
						label="Asset Group"
						help={
							this.state.assetGroupFieldDisabled
								? 'Asset group cannot be changed as there are active assets under this location.'
								: undefined
						}
					>
						{getFieldDecorator('brandAssetGroupId', {
							initialValue: formData.brandAssetGroupId,
						})(
							<Select
								allowClear
								placeholder="Select asset group"
								loading={this.state.assetGroupsFetching}
								disabled={this.state.assetGroupFieldDisabled || this.state.assetGroupsFetching}
								options={this.state.assetGroupOptions}
							/>
						)}
					</Form.Item>
				) : null}

				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<Form.Item label="Region">
						{getFieldDecorator('regionId', {
							initialValue: formData.regionId,
						})(
							<ProblemTypeTreeSelect
								allowClear={true}
								stateSlice={regions}
								targetCollectionName={REGIONS_WITH_CHILDREN}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) =>
									fetchRegionsWithChildren(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									)
								}
								fetchMultiple={() => {}}
								renderRecord={(sf) => (
									<Select.Option key={sf.id} value={sf.id}>
										{sf.name}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				)}
				<Form.Item label="Is Active">
					{getFieldDecorator('isActive', {
						initialValue: formData.isActive === undefined ? true : formData.isActive,
						valuePropName: 'checked',
					})(<Switch />)}
				</Form.Item>
				<MultiEmailComponentAntdV3
					form={form}
					formData={formData}
					label={<span>Primary Contact's Email</span>}
					fieldProps={{
						key: `primary-contact-emails`,
						rules: [
							...(isAdmin
								? [
										{
											required: true,
											message:
												'Please give email for primary point of contact on-site at this location.',
										},
								  ]
								: []),
						],
						preserve: false,
						name: 'primaryContactsEmails',
					}}
					disabled={!isAdmin}
				/>
				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<MultiEmailComponentAntdV3
						form={form}
						formData={formData}
						label={<span>Facilities Contact's Emails</span>}
						fieldProps={{
							key: `facility-incharge-emails`,
							rules: [
								...(isAdmin
									? [
											{
												required: true,
												message:
													'Please give email for person in charge of the maintenance and repairs for this location.',
											},
									  ]
									: []),
							],
							preserve: false,
							name: 'facilityInChargeEmails',
						}}
						disabled={!isAdmin}
					/>
				)}
				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<MultiEmailComponentAntdV3
						form={form}
						formData={formData}
						label={
							<span>
								Send Approved Invoices To{' '}
								<Popover content={'This field can only be edited by admins.'}>
									<InfoCircleOutlined style={{ fontSize: 12, marginLeft: 2 }} />
								</Popover>
							</span>
						}
						fieldProps={{
							key: `send-approved-invoices-to`,
							rules: [
								{
									required: false,
									message:
										'Please enter an email for approved invoices to be sent to for this location.',
								},
							],
							preserve: false,
							tooltip:
								'These email addresses will be emailed approved invoices. You can enter multiple emails seperated by comma',
							name: 'sendApprovedInvoicesToEmails',
						}}
						disabled={!isAdmin}
					/>
				)}

				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<MultiEmailComponentAntdV3
						form={form}
						formData={formData}
						label={
							<span>
								Send Approved Quotes To{' '}
								<Popover content={'This field can only be edited by admins.'}>
									<InfoCircleOutlined style={{ fontSize: 12, marginLeft: 2 }} />
								</Popover>
							</span>
						}
						fieldProps={{
							key: `send-approved-quotes-to`,
							rules: [
								{
									required: false,
									message:
										'Please enter an email for approved quotes to be sent to for this location.',
								},
							],
							preserve: false,
							tooltip:
								'These email addresses will be emailed approved quotes. You can enter multiple emails seperated by comma',
							name: 'sendApprovedQuotesToEmails',
						}}
						disabled={!isAdmin}
					/>
				)}

				{enableBillTo && !isSupplierPayingCustomerAndAdmin(currentUser) ? (
					<>
						<div className="h5medium mb-2 mt-6 ">Invoice Bill To</div>
						<div className="mb-6 border border-solid border-grey-4 p-4">
							<Form.Item label="Bill To">
								{getFieldDecorator('invoiceBillTo', {
									rules: [
										{
											required: true,
											message: 'Bill To is required',
										},
									],
								})(<Input placeholder="Company or entity name to bill to" />)}
							</Form.Item>
							<Form.Item label="Service Address">
								{getFieldDecorator('invoiceServiceAddressSameAsLocation', {
									initialValue: isSameAsLocation,
									valuePropName: 'checked',
								})(
									<Checkbox onChange={this.handleInvoiceServiceAddressSameAsLocationChange}>
										Same as location address
									</Checkbox>
								)}
							</Form.Item>
							{!sameAsLocationChecked ? (
								<>
									<Form.Item label="Street Address 1">
										{getFieldDecorator('invoiceServiceAddress-streetAddress1', {
											rules: [
												{
													required: true,
													message: 'Street address is required',
												},
											],
										})(<Input placeholder="Street address" />)}
									</Form.Item>
									<Form.Item label="Street Address 2">
										{getFieldDecorator('invoiceServiceAddress-streetAddress2Opt')(
											<Input placeholder="Apt, suite, unit, etc. (optional)" />
										)}
									</Form.Item>
									<Form.Item label="City">
										{getFieldDecorator('invoiceServiceAddress-city', {
											rules: [
												{
													required: true,
													message: 'City is required',
												},
											],
										})(<Input placeholder="City, State, Zip, Country" />)}
									</Form.Item>
								</>
							) : null}
						</div>
					</>
				) : null}

				<Form.Item label="Currency">
					{form.getFieldDecorator('currencyId', {
						rules: [{ required: true, message: 'Please select a currency for this event.' }],
						initialValue: getCurrency({ location: formData }).id || 'USD',
					})(
						<Select
							showSearch={true}
							optionFilterProp="children"
							filterOption={filterCurrencyOption}
							placeholder="Currency"
						>
							{currencyRecordsList.map((currency) => (
								<Select.Option key={currency.id} value={currency.id}>
									{capitalize(currency.displayNamePlural)} ({currency.id})
								</Select.Option>
							))}
						</Select>
					)}
				</Form.Item>
				{isSupplierPayingCustomerAndAdmin(currentUser) ? null : (
					<Form.Item label="Location Type">
						{getFieldDecorator('locationTypeId', {
							initialValue: formData.locationTypeId,
							rules: [{ required: true, message: 'This field is required.' }],
						})(
							<Select
								notFoundContent={locationTypesFetching ? <Spin size="small" /> : null}
								placeholder="Type to search for location type"
								filterOption={false}
								showSearch={true}
								onSearch={this.searchLocationTypes}
								onChange={this.handleLocationTypeChange}
							>
								{locationTypesDropdownRecords.map((d) => (
									<Select.Option value={d.id} key={d.id}>
										{d.name}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
				)}
				{getFieldItems(locationType)}
				<PhoneNumberComponent
					form={form}
					label="Phone Number"
					fieldProps={{
						initialValue: formData.phoneNumber,
						name: 'phoneNumber',
					}}
				/>
				<Form.Item label="Photos">
					{getFieldDecorator(`images`, {
						valuePropName: 'fileList',
						getValueFromEvent: normFile,
						initialValue: this.state.allPhotos,
					})(
						<OWUpload
							accept="image/*"
							name="file"
							listType="picture-card"
							className="avatar-uploader"
							multiple={true}
							headers={uploadHeaders}
							onPreview={this.handlePreview}
							action={`${BACKEND_URI}/api/v1/${userType}/file/upload`}
							beforeUpload={imageUploadValidation}
							onChange={this.handleImageUpdate}
						>
							<div style={{ display: 'inline' }}>
								<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
								<div className="ant-upload-text">Upload</div>
							</div>
							<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
								<img alt="example" style={{ width: '100%' }} src={previewImage} />
							</Modal>
						</OWUpload>
					)}
				</Form.Item>
				<Form.Item label="Is Leased?">
					{getFieldDecorator('isLeased', {
						initialValue: formData.isLeased === undefined ? false : formData.isLeased,
						valuePropName: 'checked',
					})(<Switch />)}
				</Form.Item>
				{form.getFieldValue(`isLeased`)
					? [
							<Form.Item label="Lease Start and End Date">
								{getFieldDecorator('leasePeriod', {
									initialValue: [
										formData.leaseStartDate ? moment(formData.leaseStartDate) : undefined,
										formData.leaseEndDate ? moment(formData.leaseEndDate) : undefined,
									],
									rules: [
										{
											required: true,
											message: 'Must enter the Lease start or end date.',
											validator: (rule, value, callback) => {
												if (value === null || !value[1]) {
													callback('error');
													return Promise.reject('');
												}
												return Promise.resolve();
											},
										},
									],
								})(<OWDateRangePicker format={dateFormat} onChange={this.handleLeaseDateChange} />)}
							</Form.Item>,
					  ]
					: null}
				{buildingWarrantyEnabled ? (
					<>
						<Form.Item label="Building Warranty Start and End Date">
							{getFieldDecorator('buildingWarrantyPeriod', {
								initialValue: [
									nullSafeGet('buildingWarrantyStartDate', formData)
										? moment(formData.buildingWarrantyStartDate)
										: undefined,
									nullSafeGet('buildingWarrantyExpirationDate', formData)
										? moment(formData.buildingWarrantyExpirationDate)
										: undefined,
								],
							})(<OWDateRangePicker format={dateFormat} />)}
						</Form.Item>
						{buildingWarrnatyPeriodSelected ? (
							<>
								<div className="flex flex-col" style={{ maxWidth: 640 }}>
									<div className="mb-2 flex flex-row items-center justify-between">
										<span>{'Warranty Associated Problem Type'}</span>
										<div className="flex flex-row items-center">
											<span className="mr-2">Select All</span>
											<Form.Item style={{ marginBottom: 0, paddingBottom: 0 }}>
												{getFieldDecorator('allProblemTypes', {
													initialValue: !nullSafeGet('buildingWarrantyProblemTypeIds.0', formData),
													valuePropName: 'checked',
												})(<Switch size="small" />)}
											</Form.Item>
										</div>
									</div>
									<Form.Item>
										{getFieldDecorator('buildingWarrantyProblemTypeIds', {
											initialValue: formData.buildingWarrantyProblemTypeIds || [],
											rules: [
												{
													type: 'array',
													required: false,
													message: 'Please select a problem type',
												},
											],
										})(
											<ProblemTypeTreeSelect
												mode="multiple"
												stateSlice={problemTypes}
												targetCollectionName={LOCATION_FORM_AUTOCOMPLETE}
												fetchMultiple={() => {}}
												fetchData={(
													searchText,
													targetCollectionName,
													pagination,
													sorting,
													filters,
													addToTargetCollection
												) =>
													fetchProblemTypes(
														{ name: searchText },
														targetCollectionName,
														pagination,
														sorting,
														filters,
														addToTargetCollection
													)
												}
												placeholder={'Select Problem Types'}
												renderRecord={(problemType) => (
													<Select.Option key={problemType.id} value={problemType.id}>
														{problemType.hierarchyName}
													</Select.Option>
												)}
												disabled={allProblemTypesSelected}
											/>
										)}
									</Form.Item>
								</div>
								<Form.Item
									label="Default Building Warranty Supplier"
									help="If left empty, rank 1 supplier will get picked based on problem type and location."
								>
									{getFieldDecorator('buildingWarrantyServiceProviderId', {
										initialValue: formData.buildingWarrantyServiceProviderId,
									})(
										<OWAsyncSelect
											allowClear={true}
											stateSlice={supplierFacilities}
											targetCollectionName={LOCATION_FORM_AUTOCOMPLETE}
											fetchMultiple={(ids, targetCollectionName) => {
												fetchMultipleSupplierFacilitiesInPrivateNetwork(ids, targetCollectionName);
											}}
											fetchData={(
												searchText,
												targetCollectionName,
												pagination,
												sorting,
												filters,
												addToTargetCollection
											) => {
												fetchSupplierFacilitiesInPrivateNetwork(
													{ name: searchText, offset: 0, limit: 100 },
													targetCollectionName,
													pagination,
													sorting,
													filters,
													addToTargetCollection
												);
											}}
											renderRecord={(supplierFacility) => (
												<Select.Option key={supplierFacility.id} value={supplierFacility.id}>
													{supplierFacility.name}
												</Select.Option>
											)}
											sortBy={{ sort_by: 'name', order: 'ascend' }}
										/>
									)}
								</Form.Item>
							</>
						) : null}
					</>
				) : null}
				<Form.Item label="Open Date">
					{getFieldDecorator('openDate', {
						initialValue: formData.openDate ? moment(formData.openDate) : undefined,
					})(
						<DatePicker
							disabledDate={(current) => current && current > moment()}
							format="MM-DD-YYYY"
							placeholder={'Open Date'}
						/>
					)}
				</Form.Item>
				<Form.Item label="Close Date">
					{getFieldDecorator('closeDate', {
						initialValue: formData.closeDate ? moment(formData.closeDate) : undefined,
					})(
						<DatePicker
							disabledDate={(current) => current && current > moment()}
							format="MM-DD-YYYY"
							placeholder={'Close Date'}
						/>
					)}
				</Form.Item>
				<CustomFieldItems
					formData={formData}
					form={form}
					getFieldDecorator={getFieldDecorator}
					customFields={this.state.customFields}
				/>
				<LocationFormHoursComponent form={form} location={formData} />
				<Form.Item>
					<OWButton
						type="primary"
						htmlType="submit"
						loading={this.state.isLoading || isImageUploading}
						className="contactForm__button"
					>
						{submitText}
					</OWButton>
					<span style={{ marginLeft: '16px' }}>
						<BackButton buttonText="Cancel" />
					</span>
				</Form.Item>
			</Form>
		);
	}
}

const mapStateToProps = (state) => ({
	locationTypesFetching: state.location_types.fetching,
	locationTypes: state.location_types,
	regionsFetching: state.regions.fetching,
	regions: state.regions,
	buyerContactsFetching: state.buyer_contacts.fetching,
	buyerContacts: state.buyer_contacts,
	createErrors: state.locations.createErrors,
	updateErrors: state.locations.updateErrors,
	creating: state.locations.creating,
	updating: state.locations.updating,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	problemTypes: state.problem_types,
	supplierFacilities: state.supplier_facilities,
	brands: state.brands,
	customers: state.customers,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	update: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.update(entity)
				: locationsRestCrudThunksForBuyer.update(entity)
		),
	create: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.create(entity)
				: locationsRestCrudThunksForBuyer.create(entity)
		),
	createBuyerFacility: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? buyerFacilitiesRestCrudThunksForSupplier.create(entity)
				: buyerFacilitiesRestCrudThunksForBuyer.create(entity)
		),
	updateBuyerFacility: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? buyerFacilitiesRestCrudThunksForSupplier.update(entity)
				: buyerFacilitiesRestCrudThunksForBuyer.update(entity)
		),
	fetchLocationType: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationTypesRestCrudThunksForSupplier.readOne(id)
				: locationTypesRestCrudThunksForBuyer.readOne(id)
		),
	fetchLocationTypes: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationTypesRestCrudThunksForSupplier.read(
						params,
						LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE
				  )
				: locationTypesRestCrudThunksForBuyer.read(
						params,
						LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE
				  )
		),
	fetchRegion: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? regionsRestCrudThunksForSupplier.readOne(id)
				: regionsRestCrudThunksForBuyer.readOne(id)
		),
	fetchRegions: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? regionsRestCrudThunksForSupplier.read(params, LOCATION_FORM_REGIONS_AUTOCOMPLETE)
				: regionsRestCrudThunksForBuyer.read(params, LOCATION_FORM_REGIONS_AUTOCOMPLETE)
		),
	fetchRegionsWithChildren: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchRegionsWithChildrenForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: fetchRegionsWithChildrenForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	createRegion: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? regionsRestCrudThunksForSupplier.create(entity)
				: regionsRestCrudThunksForBuyer.create(entity)
		),
	fetchBuyerContacts: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? buyerContactsRestCrudThunksForSupplier.read(
						params,
						LOCATION_FORM_BUYER_CONTACTS_AUTOCOMPLETE
				  )
				: buyerContactsRestCrudThunksForBuyer.read(
						params,
						LOCATION_FORM_BUYER_CONTACTS_AUTOCOMPLETE
				  )
		),
	fetchBrands: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.read(params, 'brandsIndex')
				: brandsRestCrudThunksForBuyer.read(params, 'brandsIndex')
		),
	getCustomFields: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? getCustomFieldsForSupplier(params)
				: getCustomFieldsForBuyer(params)
		),
	fetchCustomers: (params) =>
		dispatch(customersRestCrudThunksForSupplier.read(params, 'customersIndex')),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier
				: problemTypesHeirarchicalForBuyer;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchSupplierFacilitiesInPrivateNetworkForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: fetchSupplierFacilitiesInPrivateNetworkForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
	fetchMultipleSupplierFacilitiesInPrivateNetwork: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchBrandAssetGroups: (brandId) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandAssetGroupsRestCrudThunksForSupplier.read({ brandId, no_pagination: true })
				: brandAssetGroupsRestCrudThunksForBuyer.read({ brandId, no_pagination: true })
		),
	countAssets: (params) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? assetsRestCrudThunksForSupplier.countBy(params, 'locationAssetCount')
				: assetsRestCrudThunksForBuyer.countBy(params, 'locationAssetCount')
		),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Form.create()(LocationForm))
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
